import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { formatDateWithTime } from '../../../../utils/dateUtils';
import { useLanguage } from '../../../../contexts/LanguageContext';

/**
 * Bağımsız Planlamalar sayfasının listesi — artık tek bir eğitime değil, tüm eğitimlerin
 * planlamalarına ait satırları gösterir; bu yüzden (eski `PlanningTab.jsx`'ten farklı olarak)
 * "Eğitim Kodu" ve "Eğitim Adı" sütunları eklendi (GetList her satırda bunları döndürüyor,
 * doc §8.3). Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 2.md §8.
 */
const PlanningTable = ({ plannings, loading, onEdit }) => {
    const { th } = useLanguage();

    // startDate/endDate ("YYYY-MM-DD") ile startTime/endTime ("HH:mm:ss") ayrı alanlar (doc §8.1);
    // listede tek sütunda birleştirilerek gösterilir.
    const combinedDateTime = (dateValue, timeValue) => {
        if (!dateValue) return '';
        const timePart = timeValue ? ` ${timeValue.slice(0, 5)}` : '';
        return `${formatDateWithTime(dateValue, false)}${timePart}`;
    };

    const isActiveBodyTemplate = (row) => (Number(row.isActive) === 0 ? th('common.inactive', { fallback: 'Pasif' }) : th('common.active', { fallback: 'Aktif' }));

    const feeBodyTemplate = (row) => (row.fee != null ? `${row.fee} ${row.currency || ''}`.trim() : '');

    const actionBodyTemplate = (row) => (
        <div className="flex gap-2 justify-content-center">
            <i className="pi pi-pencil cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem' }} title={th('common.edit')} onClick={() => onEdit(row)} />
        </div>
    );

    return (
        <DataTable value={plannings} loading={loading} dataKey="id" emptyMessage={th('trainingPlanning.emptyMessage')} className="p-datatable-gridlines" showGridlines>
            <Column body={actionBodyTemplate} style={{ width: '4rem' }} align="center" />
            <Column field="trainingCode" header={th('trainingPlanning.columnTrainingCode')} style={{ width: '9rem' }} />
            <Column field="trainingName" header={th('trainingPlanning.columnTrainingName')} />
            <Column field="startDate" header={th('trainingPlanning.columnStart')} style={{ width: '11rem' }} body={(row) => combinedDateTime(row.startDate, row.startTime)} />
            <Column field="endDate" header={th('trainingPlanning.columnEnd')} style={{ width: '11rem' }} body={(row) => combinedDateTime(row.endDate, row.endTime)} />
            <Column field="planningLocationText" header={th('trainingPlanning.columnLocation')} style={{ width: '10rem' }} />
            <Column field="trainingDay" header={th('trainingPlanning.columnTrainingDay')} style={{ width: '9rem' }} />
            <Column field="trainingDuration" header={th('trainingPlanning.columnTrainingDuration')} style={{ width: '8rem' }} />
            <Column field="fee" header={th('trainingPlanning.columnFee')} style={{ width: '10rem' }} body={feeBodyTemplate} />
            <Column field="isActive" header={th('common.status')} style={{ width: '8rem' }} body={isActiveBodyTemplate} />
        </DataTable>
    );
};

export default PlanningTable;
